import { createSelector } from 'reselect';
import { createFeatureSelector } from 'common/create-feature-selector';

export const rootSelector = createFeatureSelector('activeRegionId');
export const getActiveRegionId = createSelector(rootSelector, (r) => r);
